// Dados centralizados da equipe da Clínica Habitus

import odiliaImg from '@/assets/team/odilia.jpg?format=webp';
import odiliaSrcset from '@/assets/team/odilia.jpg?w=320;640&format=webp&as=srcset';
import larissaImg from '@/assets/team/larissa.jpg?format=webp';
import larissaSrcset from '@/assets/team/larissa.jpg?w=320;640&format=webp&as=srcset';
import mateusImg from '@/assets/team/mateus.jpg?format=webp';
import mateusSrcset from '@/assets/team/mateus.jpg?w=320;640&format=webp&as=srcset';
import marianaImg from '@/assets/team/mariana.jpg?format=webp';
import marianaSrcset from '@/assets/team/mariana.jpg?w=320;640&format=webp&as=srcset';

export interface TeamMember {
  id: number;
  name: string;
  role: string;
  /**
   * Número de inscrição no conselho profissional. Para médicos é obrigatório
   * junto ao nome (Resolução CFM 2.336/2023, art. 4º, I). Especialidade só
   * pode ser anunciada com o número do RQE (art. 4º, II) — sem RQE, não
   * escrever "especialista" em lugar nenhum.
   */
  registro?: string;
  image: string;
  srcSet: string;
}

export const TEAM_MEMBERS: TeamMember[] = [
  {
    id: 1,
    name: 'Odilia',
    role: 'Nutricionista',
    image: odiliaImg,
    srcSet: odiliaSrcset,
  },
  {
    id: 2,
    name: 'Larissa',
    role: 'Nutricionista',
    registro: 'CRN-1 22407',
    image: larissaImg,
    srcSet: larissaSrcset,
  },
  {
    id: 3,
    name: 'Dr. Mateus Soares',
    role: 'Médico · Diretor Técnico',
    registro: 'CRM-DF 24705',
    image: mateusImg,
    srcSet: mateusSrcset,
  },
  {
    id: 5,
    name: 'Mariana Gualberto',
    role: 'Ozonioterapeuta',
    registro: 'COREN-DF 630061-ENF',
    image: marianaImg,
    srcSet: marianaSrcset,
  },
];
